mutation approveMarketingPlanSlots($input: ApproveSlotsInput!) {
  results: approveMarketingPlanSlots(input: $input) {
    slotId
    outcome
    code
    reason
  }
}
